import { AccessOutlet } from "./AppLayout";

/**
 * Full-screen layout of the theme editor (T11-42, design/03 §5): no sidebar, no bottom bar, no
 * header — the editor brings its own top bar with "back". The same access rules as the shell apply
 * (a hidden entry opened by URL shows "no access"). Leaving the editor returns to the shell with
 * its cached data (one QueryClient for the whole app), so the list is not loaded again.
 */
export function EditorLayout() {
  return (
    <div className="flex min-h-dvh flex-col" data-layout="editor">
      <AccessOutlet />
    </div>
  );
}
